const getInitialTaskQuota = () => {
    return {
        total_sample_size: null,
        quota_full_message: null,
        match_handling: null,
        enable_waiting_list: null,
        current_count: 0,
        groups: []
    }
};

export default getInitialTaskQuota;